import { createMapStore } from "./stores/createMapStore";

const useFilterMap = createMapStore("map-filter-store", {
    mapMode: "global",
    mapCountry: null,
    mapState: null,
    mapCity: null,
    level: null,
});

export default useFilterMap;
